import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import { toast } from 'react-toastify';
import { FiBook, FiClock, FiTag, FiShoppingCart, FiPlay, FiCheckCircle, FiChevronRight, FiShare2,FiX } from 'react-icons/fi';
import { FaFacebook, FaTwitter, FaWhatsapp, FaLinkedin, FaTelegram, FaLink } from 'react-icons/fa';
import { API_BASE_URL, BASE_URL, razorpay_key } from '../config/config';

const CourseDetailsPage = () => {

  const { courseId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [demoVideos, setDemoVideos] = useState([]);
  const [loading, setLoading] = useState(true);
 const settings=JSON.parse(localStorage.getItem('settings'));
 const [showShareModal, setShowShareModal] = useState(false);
 
  const isLoggedIn = !!user;

  useEffect(() => {
    fetchCourseDetails();
    fetchDemoVideos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseId]);

  const fetchCourseDetails = async () => {
    try {
      const email = isLoggedIn ? user.email : 'guest@example.com';
      const response = await fetch(`${API_BASE_URL}/popularcourse?email=${email}&type=all`);
      const data = await response.json();
      
      if (data.success) {
        const foundCourse = data.data.find(c => c.id === parseInt(courseId));
        if (foundCourse) {
          setCourse(foundCourse);
        }
      }
    } catch (error) {
      console.error('Error fetching course:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDemoVideos = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/demovideos/${courseId}`);
      const data = await response.json();
      
      if (data.success) {
        setDemoVideos(data.data);
      }
    } catch (error) {
      console.error('Error fetching demo videos:', error);
    }
  };

  const handlePurchase = async () => {
   
    if (!isLoggedIn) {
      localStorage.setItem('intendedCourse', JSON.stringify(course));
      navigate('/login', { state: { from: `/course-details/${courseId}`, message: 'Please login to purchase this course' } });
      return;
    }

    if (!window.Razorpay) {
      alert('Payment gateway not loaded. Please refresh the page.');
      return;
    }

    try {
      // Phase 1: Create order on backend BEFORE opening Razorpay
      const orderResponse = await fetch(`${API_BASE_URL}/create-course-order`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          course_id: course.id,
          user_id: user.id,
          email: user.email,
          mobile: user.mobileno
        })
      });
      
      const orderData = await orderResponse.json();
      
      if (!orderData.success) {
        alert('❌ Failed to create order: ' + (orderData.message || 'Unknown error'));
        return;
      }
      
      // Phase 2: Open Razorpay with order_id
      const options = {
        key: orderData.key,
        amount: orderData.amount * 100,
        currency: 'INR',
        name: course.title,
        description: orderData.course_title,
        image: `${course.course_thumbnail}`,
        order_id: orderData.order_id,
        webview_intent: true,
        callback_url: `${window.location.origin}/payment-callback`,
        handler: async function (response) {
          try {
            // Verify payment on backend
            const verifyResponse = await fetch(`${API_BASE_URL}/verify-course-payment`, {
              method: 'POST',
              headers: { 
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature
              })
            });
            
            const verifyData = await verifyResponse.json();
            
            if (verifyData.success) {
              alert('🎉 Course purchased successfully!');
              navigate('/my-courses');
            } else {
              alert('❌ Payment verification failed. Your payment is safe and will be processed automatically. Please check "My Courses" in a few minutes or contact support.');
            }
          } catch (error) {
            console.error('Payment verification failed:', error);
            alert('⚠️ Payment completed but verification failed. Your payment is safe and will be processed automatically. Please check "My Courses" in a few minutes or contact support.');
          }
        },
        prefill: {
          name: `${user.firstname} ${user.lastname}`,
          email: user.email,
          contact: user.mobileno
        },
        theme: {
          color: '#6366f1'
        },
        modal: {
          ondismiss: function() {
            console.log('Payment cancelled by user');
          }
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
      
    } catch (error) {
      console.error('Error initiating payment:', error);
      alert('❌ Failed to initiate payment. Please try again.');
    }
  };

  const viewContent = () => {
    if (!isLoggedIn) {
      navigate('/login', { state: { message: 'Please login to view course content' } });
      return;
    }
    navigate(`/course/${courseId}`);
  };

 

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <PublicHeader />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="animate-pulse">
            <div className="bg-gray-200 h-96 rounded-lg mb-8"></div>
            <div className="bg-gray-200 h-8 rounded w-3/4 mb-4"></div>
            <div className="bg-gray-200 h-4 rounded w-1/2"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!course) {
    return (
      <div className="min-h-screen bg-gray-50">
        <PublicHeader />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Course Not Found</h2>
          <Link to="/courses" className="btn-primary inline-block">
            Browse All Courses
          </Link>
        </div>
      </div>
    );
  }

  const finalPrice = (course.price - (course.price * course.discount / 100)).toFixed(2);
  const isPurchased = course.purchased > 0;

  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm text-gray-600 mb-6">
          <Link to="/" className="hover:text-primary-600">Home</Link>
          <FiChevronRight className="w-4 h-4" />
          <Link to="/courses" className="hover:text-primary-600">Courses</Link>
          <FiChevronRight className="w-4 h-4" />
          <span className="text-gray-900 font-medium">{course.title}</span>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Left Column - Main Content */}
          <div className="lg:col-span-2">
            {/* Course Title First */}
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {course.title}
            </h1>

            {/* Course Meta */}
            <div className="flex flex-wrap items-center gap-4 mb-6 text-sm">
              <span className="flex items-center gap-1 text-gray-600">
                <FiTag className="w-4 h-4" />
                {course.tradeName || 'General'}
              </span>
              {course.validity && (
                <span className="flex items-center gap-1 text-gray-600">
                  <FiClock className="w-4 h-4" />
                  Valid for {course.validity} months
                </span>
              )}
            </div>

            {/* Course Hero Image */}
            <div className="relative rounded-xl overflow-hidden mb-8 shadow-xl">
              <img
                src={`${course.course_thumbnail}`}
                alt={course.title}
                className="w-full h-96 object-cover"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="1200" height="600"%3E%3Crect fill="%236366f1" width="1200" height="600"/%3E%3C/svg%3E';
                }}
              />
            </div>

            {/* About This Course */}
            <div className="card mb-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center text-2xl">
                  📚
                </div>
                <h2 className="text-2xl font-bold text-gray-900">About This Course</h2>
              </div>
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                {course.description ? course.description.replace(/(<([^>]+)>)/gi, '') : 'No description available.'}
              </p>
            </div>

            {/* What You'll Learn */}
            <div className="card mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">✅ What You'll Learn</h2>
              <div className="grid md:grid-cols-2 gap-3">
                <div className="flex items-center gap-2">
                  <FiCheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                  <span className="text-gray-700">Complete course content access</span>
                </div>
                <div className="flex items-center gap-2">
                  <FiCheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                  <span className="text-gray-700">High-quality video lectures</span>
                </div>
                <div className="flex items-center gap-2">
                  <FiCheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                  <span className="text-gray-700">Downloadable PDF materials</span>
                </div>
                <div className="flex items-center gap-2">
                  <FiCheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                  <span className="text-gray-700">Practice test series & quizzes</span>
                </div>
                <div className="flex items-center gap-2">
                  <FiCheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                  <span className="text-gray-700">Lifetime access to content</span>
                </div>
                <div className="flex items-center gap-2">
                  <FiCheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                  <span className="text-gray-700">Course completion certificate</span>
                </div>
              </div>
            </div>

            {/* Course Preview Video */}
            {course.course_url && (
              <div className="card mb-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center text-2xl">
                    🎥
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900">Course Preview</h2>
                </div>
                <div className="relative pt-[56.25%] bg-gray-900 rounded-lg overflow-hidden">
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src={`https://www.youtube.com/embed/${course.course_url}`}
                    title="Course Preview"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            )}

            {/* Free Demo Videos */}
            {demoVideos.length > 0 && (
              <div className="card">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-lg flex items-center justify-center text-2xl">
                    🎬
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900">Free Demo Videos</h2>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  {demoVideos.map((video) => (
                    <a
                      key={video.id}
                      href={`https://www.youtube.com/watch?v=${video.video_id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group"
                    >
                      <div className="relative rounded-lg overflow-hidden mb-2">
                        <img
                          src={`https://img.youtube.com/vi/${video.video_id}/mqdefault.jpg`}
                          alt={video.title}
                          className="w-full h-40 object-cover group-hover:scale-105 transition-transform"
                        />
                        <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/50 transition-colors">
                          <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center">
                            <FiPlay className="w-8 h-8 text-primary-600 ml-1" />
                          </div>
                        </div>
                      </div>
                      <h3 className="font-semibold text-gray-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                        {video.title}
                      </h3>
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Right Column - Pricing Card */}
          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <div className="card bg-white shadow-xl">
                {/* Price */}
                <div className="mb-6">
                  <div className="text-4xl font-bold text-primary-600 mb-2">
                    ₹{finalPrice}
                  </div>
                  {course.discount > 0 && (
                    <div className="flex items-center gap-2">
                      <span className="text-xl text-gray-500 line-through">
                        ₹{course.price.toFixed(2)}
                      </span>
                      <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-bold">
                        {course.discount}% OFF
                      </span>
                    </div>
                  )}
                </div>

                {/* Action Button */}
                {isPurchased ? (
                  <button
                    onClick={viewContent}
                    className="btn-primary w-full mb-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700"
                  >
                    <FiBook className="inline mr-2" />
                    View Full Content
                  </button>
                ) : (
                  <button
                    onClick={handlePurchase}
                    className="btn-primary w-full mb-3"
                  >
                    <FiShoppingCart className="inline mr-2" />
                    Buy Now
                  </button>
                )}

                {/* Share Button */}
                {/* Share Button */}
                <button
                  onClick={() => setShowShareModal(true)}
                  className="w-full py-3 px-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg font-semibold hover:from-blue-600 hover:to-indigo-700 transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2 mb-6"
                >
                  <FiShare2 className="w-5 h-5" />
                  Share This Course
                </button>

                {/* Course Includes */}
                <div className="border-t pt-6">
                  <h3 className="font-bold text-gray-900 mb-4">This course includes:</h3>
                  <ul className="space-y-3 text-sm text-gray-700">
                    <li className="flex items-center gap-2">
                      <FiCheckCircle className="w-5 h-5 text-green-500" />
                      Full lifetime access
                    </li>
                    <li className="flex items-center gap-2">
                      <FiCheckCircle className="w-5 h-5 text-green-500" />
                      Video lectures
                    </li>
                    <li className="flex items-center gap-2">
                      <FiCheckCircle className="w-5 h-5 text-green-500" />
                      PDF study materials
                    </li>
                    <li className="flex items-center gap-2">
                      <FiCheckCircle className="w-5 h-5 text-green-500" />
                      Test series & quizzes
                    </li>
                    <li className="flex items-center gap-2">
                      <FiCheckCircle className="w-5 h-5 text-green-500" />
                      AI-powered practice tests
                    </li>
                    <li className="flex items-center gap-2">
                      <FiCheckCircle className="w-5 h-5 text-green-500" />
                      Certificate of completion
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
          {/* Share Modal Popup */}
      {showShareModal && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
          onClick={() => setShowShareModal(false)}
        >
          <div 
            className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 relative"
            onClick={(e) => e.stopPropagation()}
            style={{animation: 'fadeIn 0.2s ease-out'}}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowShareModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <FiX className="w-6 h-6" />
            </button>

            {/* Modal Content */}
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <FiShare2 className="w-8 h-8 text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Share This Course
              </h3>
              
              <p className="text-gray-600 mb-6">
                Help your friends discover quality education
              </p>

              {/* Share Buttons - Properly Centered for Mobile */}
              <div className="flex flex-wrap justify-center items-center gap-3 mb-6">
                {/* Facebook */}
                <a
                  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`https://testmeter.in/course-details/${course.id}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-600 text-white p-3 rounded-full hover:bg-blue-700 transition-colors duration-200 shadow-lg"
                  aria-label="Share on Facebook"
                >
                  <FaFacebook className="w-6 h-6" />
                </a>

                {/* Twitter */}
                <a
                  href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(`https://testmeter.in/course-details/${course.id}`)}&text=${encodeURIComponent(`Check out ${course.title} on Testmeter!`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-sky-500 text-white p-3 rounded-full hover:bg-sky-600 transition-colors duration-200 shadow-lg"
                  aria-label="Share on Twitter"
                >
                  <FaTwitter className="w-6 h-6" />
                </a>

                {/* WhatsApp */}
                <a
                  href={`https://wa.me/?text=${encodeURIComponent(`Check out ${course.title} on Testmeter!`)}%20${encodeURIComponent(`https://testmeter.in/course-details/${course.id}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 text-white p-3 rounded-full hover:bg-green-600 transition-colors duration-200 shadow-lg"
                  aria-label="Share on WhatsApp"
                >
                  <FaWhatsapp className="w-6 h-6" />
                </a>

                {/* LinkedIn */}
                <a
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(`https://testmeter.in/course-details/${course.id}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-700 text-white p-3 rounded-full hover:bg-blue-800 transition-colors duration-200 shadow-lg"
                  aria-label="Share on LinkedIn"
                >
                  <FaLinkedin className="w-6 h-6" />
                </a>

                {/* Telegram */}
                <a
                  href={`https://t.me/share/url?url=${encodeURIComponent(`https://testmeter.in/course-details/${course.id}`)}&text=${encodeURIComponent(`Check out ${course.title} on Testmeter!`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-sky-400 text-white p-3 rounded-full hover:bg-sky-500 transition-colors duration-200 shadow-lg"
                  aria-label="Share on Telegram"
                >
                  <FaTelegram className="w-6 h-6" />
                </a>

                {/* Copy Link */}
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(`https://testmeter.in/course-details/${course.id}`);
                    toast.success('Link copied to clipboard!');
                  }}
                  className="bg-gray-600 text-white p-3 rounded-full hover:bg-gray-700 transition-colors duration-200 shadow-lg"
                  aria-label="Copy link"
                >
                  <FaLink className="w-6 h-6" />
                </button>
              </div>

              {/* Referral Section */}
              {user && (
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-xl p-4 text-left mb-4">
                  <p className="text-sm font-semibold text-gray-800 mb-2">
                    💰 Share & Help Others!
                  </p>
                  <p className="text-xs text-gray-600 mb-3">
                  Share with your friends and family to get benefits when they enroll
                  </p>
                  <div className="bg-white rounded-lg p-2 border border-gray-200 flex items-center justify-between gap-2">
                    <span className="text-xs text-gray-600 truncate flex-1">
                      {`testmeter.in/course-details/${course.id}?ref=${user.id}`}
                    </span>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(`https://testmeter.in/course-details/${course.id}?ref=${user.id}`);
                        toast.success('Referral link copied!');
                      }}
                      className="px-3 py-1 bg-blue-600 text-white text-xs rounded-md hover:bg-blue-700 flex-shrink-0"
                    >
                      Copy
                    </button>
                  </div>
                </div>
              )}

              {/* Close Button */}
              <button
                onClick={() => setShowShareModal(false)}
                className="w-full py-2 px-4 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      </div>

      <Footer />
    </div>
  );
};

export default CourseDetailsPage;

